import { Component, Input } from '@angular/core';
import { TableColumn } from 'src/app/shared/components/table/table-column.interface';
import { TableSearchRequest } from 'src/app/shared/components/table/table.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UserDetailsComponent } from 'src/app/users/user-details/user-details.component';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-company-group-users',
  templateUrl: './company-group-users.component.html',
  styleUrls: ['./company-group-users.component.scss']
})
export class CompanyGroupUsersComponent {

  @Input() companyGroupId!: number;
  isLoadingResults: boolean = false;
  userList: any[] =[];
  lastRequest?: TableSearchRequest;

  resultsLength: number = 0;

  faPlus = faPlus;

  columns: TableColumn[] = [
  { key: 'firstName',    label: 'First Name',    sortable: true, filterable: true },
  { key: 'lastName',     label: 'Last Name',     sortable: true, filterable: true },
  { key: 'emailAddress', label: 'Email',         sortable: true, filterable: true },
  { key: 'roleName',     label: 'Role',          sortable: true, filterable: true },
   { key: 'accountDisabled', label: 'Status', sortable: true, filterable: true, filterType: 'select',
    filterOptions: [
      { label: 'Enabled',  value: '{{bool}}false' },
      { label: 'Disabled', value: '{{bool}}true' }
    ]
  },
  { key: 'lastLogin', label: 'Last Login', sortable: true, filterable: true, filterType: 'daterange' },
  { key: 'lastActivity', label: 'Last Activity', sortable: true },
];

constructor(
              public modalService: ModalService,
              private userService: UserService,
              private toastService: ToastService) 
  {
  }


  ngOnChanges(): void {
    // if the table has already emitted a request, re-run it with the new id
    if (this.companyGroupId && this.lastRequest) {
      this.loadUsers(this.lastRequest);
    }
  }

  onSearch(request: TableSearchRequest) {
      this.lastRequest = request;
      if (!this.companyGroupId) return;
      this.loadUsers(request);
    }

  private loadUsers(request: TableSearchRequest) {
    this.isLoadingResults = true;
    this.userService.companyGroupUserList(this.companyGroupId, request).subscribe({
      next: data => {
        this.userList = data.items;
        this.resultsLength = data.recordCount;
        this.isLoadingResults = false;
      },
      error: () => {
        this.toastService.error('Failed to load users.');
        this.isLoadingResults = false;
      }
    });
  }

  isOnline(lastActivity: string): boolean {
    if (!lastActivity) return false;
    const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000);
    return new Date(lastActivity) > fiveMinutesAgo;
}

getRoleName(test: any){
  return 'test';
}

editUser(user: any){
   const modalRef = this.modalService.openWithOptions(UserDetailsComponent, {size: 'lg'});    
      modalRef.componentInstance.userId = user.id;
      modalRef.componentInstance.companyGroupId = this.companyGroupId;
      console.log('companyGroupId', this.companyGroupId, typeof this.companyGroupId);
      modalRef.componentInstance.internalUser = this.companyGroupId === 1;
  
      modalRef.result.then(
        (result) => {
          if(result)
          {
            this.loadUsers(this.lastRequest);
          }
        }
      ,
        () => {} // dismissed - do nothing
      );
}

  addUser(){
    const modalRef = this.modalService.openWithOptions(UserDetailsComponent, {size: 'lg'});    
        modalRef.componentInstance.companyGroupId = this.companyGroupId;
        console.log('companyGroupId', this.companyGroupId, typeof this.companyGroupId);
        modalRef.componentInstance.internalUser = this.companyGroupId === 1;
    
        modalRef.result.then(
          (result) => {
            if(result)
            {
              this.loadUsers(this.lastRequest);
            }
          }
        ,
          () => {} // dismissed - do nothing
        );
  }


}
